import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { globalErrorHandler } from './lib/globalErrorHandler'
import { initializeRevenueCat } from './lib/revenueCatInit'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { attemptOTARecovery } from './lib/capgoUpdateHealth'

// Initialize global error handling
globalErrorHandler.init();

// Notify Capgo that the current bundle loaded successfully (prevents rollback)
CapacitorUpdater.notifyAppReady().catch(() => {
  // Silently fail on web — only relevant on native
});

// Background OTA self-healing: if the device is stuck on a stale/builtin bundle,
// download and queue the latest version so it activates on next launch.
// This is non-blocking and fire-and-forget.
setTimeout(() => {
  attemptOTARecovery().catch(() => {});
}, 3000);

// Initialize RevenueCat SDK early (before React renders)
// This ensures the SDK is configured before AuthContext tries to use it
initializeRevenueCat().then((success) => {
  if (success) {
    console.log('RevenueCat: SDK ready before app render');
  }
});

const root = document.getElementById("root")!;
document.getElementById('initial-loader')?.remove();
document.getElementById('prerender')?.remove();

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
